export const addUserIdToUrl = (url: string, userId: string): string =>
  userId ? `${url}/?user_id=${userId}` : url
